import {
  Button,
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Modal,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input,
  Label,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import { useEffect, useState } from "react";
import Header from "components/Headers/Header.js";
import Loader from "components/Loader.js"; // ✅ Import do Loader
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const TableCountries = () => {
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true); // ✅ Estado do loader
  const [newCountry, setNewCountry] = useState({ name: "", code: "" });
  const [modalOpen, setModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [currentCountry, setCurrentCountry] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [sortBy, setSortBy] = useState("name");
  const [sortOrder, setSortOrder] = useState("asc");

  const fetchCountries = async () => {
    try {
      const response = await axios.get(`${API_URL}/countries`);
      setCountries(response.data);
    } catch (error) {
      console.error("Erro ao buscar países:", error);
    } finally {
      setLoading(false); // ✅ Desliga o loader após o carregamento
    }
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  const toggleModal = () => setModalOpen(!modalOpen);
  const toggleEditModal = () => setEditModalOpen(!editModalOpen);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewCountry({ ...newCountry, [name]: value });
  };

  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setCurrentCountry({ ...currentCountry, [name]: value });
  };

  const handleCreateCountry = async () => {
    try {
      const response = await axios.post(`${API_URL}/countries`, newCountry);
      setCountries([...countries, response.data.country]);
      setNewCountry({ name: "", code: "" });
      toggleModal();
    } catch (error) {
      console.error("Erro ao criar país:", error);
    }
  };

  const handleEditCountry = async () => {
    try {
      const response = await axios.put(
        `${API_URL}/countries/${currentCountry.id}`,
        currentCountry
      );
      setCountries(
        countries.map((c) =>
          c.id === currentCountry.id ? response.data.country : c
        )
      );
      toggleEditModal();
    } catch (error) {
      console.error("Erro ao editar país:", error);
    }
  };

  const handleDeleteCountry = async (id) => {
    try {
      await axios.delete(`${API_URL}/countries/${id}`);
      setCountries(countries.filter((c) => c.id !== id));
    } catch (error) {
      console.error("Erro ao deletar país:", error);
      alert("Erro: não é possível excluir país com agendamentos vinculados.");
    }
  };

  const openEditModal = (country) => {
    setCurrentCountry(country);
    toggleEditModal();
  };

  const handleSort = (field) => {
    if (sortBy === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(field);
      setSortOrder("asc");
    }
  };

  const sortedCountries = [...countries].sort((a, b) => {
    const fieldA = a[sortBy].toLowerCase();
    const fieldB = b[sortBy].toLowerCase();
    if (fieldA < fieldB) return sortOrder === "asc" ? -1 : 1;
    if (fieldA > fieldB) return sortOrder === "asc" ? 1 : -1;
    return 0;
  });

  const totalPages = Math.ceil(sortedCountries.length / itemsPerPage);
  const paginatedCountries = sortedCountries.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // ✅ Mostra o Loader enquanto carrega
  if (loading) {
    return (
      <>
        <Header />
        <Loader />
      </>
    );
  }

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                <h3 className="mb-0">Lista de Países</h3>
                <Button color="info" onClick={toggleModal}>
                  Novo País
                </Button>
              </CardHeader>

              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th
                      onClick={() => handleSort("name")}
                      style={{ cursor: "pointer" }}
                    >
                      Nome{" "}
                      {sortBy === "name" && (sortOrder === "asc" ? "↑" : "↓")}
                    </th>
                    <th
                      onClick={() => handleSort("code")}
                      style={{ cursor: "pointer" }}
                    >
                      Código{" "}
                      {sortBy === "code" && (sortOrder === "asc" ? "↑" : "↓")}
                    </th>
                    <th className="text-right" />
                  </tr>
                </thead>
                <tbody>
                  {paginatedCountries.map((country) => (
                    <tr key={country.id}>
                      <td>{country.name}</td>
                      <td>{country.code}</td>
                      <td className="text-right">
                        <UncontrolledDropdown>
                          <DropdownToggle
                            className="btn-icon-only text-light"
                            href="#pablo"
                            role="button"
                            size="sm"
                            color=""
                            onClick={(e) => e.preventDefault()}
                          >
                            <i className="fas fa-ellipsis-v" />
                          </DropdownToggle>
                          <DropdownMenu
                            container="body"
                            className="dropdown-menu-arrow"
                            right
                          >
                            <DropdownItem
                              onClick={() => openEditModal(country)}
                            >
                              Editar
                            </DropdownItem>
                            <DropdownItem
                              onClick={() =>
                                handleDeleteCountry(country.id)
                              }
                            >
                              Deletar
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              <CardFooter className="py-4">
                <Pagination className="pagination justify-content-end mb-0">
                  <PaginationItem disabled={currentPage === 1}>
                    <PaginationLink
                      href="#prev"
                      onClick={(e) => {
                        e.preventDefault();
                        if (currentPage > 1)
                          setCurrentPage(currentPage - 1);
                      }}
                    >
                      <i className="fas fa-angle-left" />
                    </PaginationLink>
                  </PaginationItem>

                  {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                    (page) => (
                      <PaginationItem
                        key={page}
                        active={page === currentPage}
                      >
                        <PaginationLink
                          href="#page"
                          onClick={(e) => {
                            e.preventDefault();
                            setCurrentPage(page);
                          }}
                        >
                          {page}
                        </PaginationLink>
                      </PaginationItem>
                    )
                  )}

                  <PaginationItem disabled={currentPage === totalPages}>
                    <PaginationLink
                      href="#next"
                      onClick={(e) => {
                        e.preventDefault();
                        if (currentPage < totalPages)
                          setCurrentPage(currentPage + 1);
                      }}
                    >
                      <i className="fas fa-angle-right" />
                    </PaginationLink>
                  </PaginationItem>
                </Pagination>
              </CardFooter>
            </Card>
          </div>
        </Row>
      </Container>

      {/* Modal: Novo País */}
      <Modal isOpen={modalOpen} toggle={toggleModal}>
        <div className="modal-header">
          <h5 className="modal-title">Criar Novo País</h5>
          <button className="close" type="button" onClick={toggleModal}>
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label for="name">Nome</Label>
              <Input
                type="text"
                id="name"
                name="name"
                value={newCountry.name}
                onChange={handleInputChange}
                placeholder="Ex: Brasil"
              />
            </FormGroup>
            <FormGroup>
              <Label for="code">Código</Label>
              <Input
                type="text"
                id="code"
                name="code"
                value={newCountry.code}
                onChange={handleInputChange}
                placeholder="Ex: BR"
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleCreateCountry}>
            Criar País
          </Button>
          <Button color="secondary" onClick={toggleModal}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal: Editar País */}
      <Modal isOpen={editModalOpen} toggle={toggleEditModal}>
        <div className="modal-header">
          <h5 className="modal-title">Editar País</h5>
          <button className="close" type="button" onClick={toggleEditModal}>
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label for="name">Nome</Label>
              <Input
                type="text"
                id="name"
                name="name"
                value={currentCountry?.name || ""}
                onChange={handleEditInputChange}
                placeholder="Ex: Brasil"
              />
            </FormGroup>
            <FormGroup>
              <Label for="code">Código</Label>
              <Input
                type="text"
                id="code"
                name="code"
                value={currentCountry?.code || ""}
                onChange={handleEditInputChange}
                placeholder="Ex: BR"
              />
            </FormGroup>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={handleEditCountry}>
            Atualizar País
          </Button>
          <Button color="secondary" onClick={toggleEditModal}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default TableCountries;